module.exports = __webpack_public_path__ + "img/Flows.d7fac7f8.png";